/* ============================================================
   MA Announcement Bar — Marquee mode
   ============================================================ */

(function () {
  'use strict';

  function initMarquee(el) {
    const track = el.querySelector('.ma-announcement-marquee__track');
    if (!track) return;

    const items = Array.from(track.children);
    if (items.length === 0) return;

    const speed = parseFloat(el.dataset.marqueeSpeed) || 80;

    // Measure the original set width (items + gaps)
    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    const originalWidth = items.reduce((sum, item) => sum + item.offsetWidth + gap, 0);

    if (originalWidth === 0) return;

    // Clone enough sets to fill at least 3× the viewport so the loop
    // is always seamless even with very few / short items
    const fillTarget = window.innerWidth * 3;
    let clonedWidth = 0;

    while (clonedWidth < fillTarget) {
      items.forEach((item) => {
        const clone = item.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
        clonedWidth += item.offsetWidth + gap;
      });
    }

    let marqueePos = 0;
    let lastTs = null;
    let rafId;

    function tick(ts) {
      if (lastTs !== null) {
        marqueePos += (speed * (ts - lastTs)) / 1000;
        if (marqueePos >= originalWidth) {
          marqueePos -= originalWidth;
        }
        track.style.transform = `translateX(${-marqueePos}px)`;
      }
      lastTs = ts;
      rafId = requestAnimationFrame(tick);
    }

    rafId = requestAnimationFrame(tick);

    // Clean up if the section is removed (e.g. theme editor)
    const observer = new MutationObserver(() => {
      if (!document.contains(el)) {
        cancelAnimationFrame(rafId);
        observer.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  document.querySelectorAll('[data-marquee-speed]').forEach(initMarquee);

  // Support theme editor section reloads
  document.addEventListener('shopify:section:load', (e) => {
    e.target.querySelectorAll('[data-marquee-speed]').forEach(initMarquee);
  });
})();
